module.exports = __webpack_public_path__ + "img/PTI_ESTETICO.0d042c43.png";